import { rankings } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 mb-3">
            热度榜单
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            实时追踪全网热议话题，看看大家都在讨论什么
          </p>
        </div>

        <div className="bg-background-50 rounded-2xl border border-background-200/60 overflow-hidden">
          {rankings.map((item, i) => (
            <a
              key={i}
              href="#cards"
              className={`flex items-center gap-4 px-5 py-4 hover:bg-primary-50/30 transition-colors cursor-pointer ${
                i < rankings.length - 1 ? 'border-b border-background-200/40' : ''
              }`}
            >
              <div className="flex-shrink-0 w-10 h-10 rounded-xl flex items-center justify-center font-heading text-lg font-bold">
                {item.rank <= 3 ? (
                  <span
                    className={`w-10 h-10 rounded-xl flex items-center justify-center text-white ${
                      item.rank === 1
                        ? 'bg-primary-500'
                        : item.rank === 2
                          ? 'bg-primary-400'
                          : 'bg-accent-500'
                    }`}
                  >
                    {item.rank}
                  </span>
                ) : (
                  <span className="text-foreground-400">{item.rank}</span>
                )}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 truncate">
                    {item.title}
                  </h3>
                  {item.trend === 'new' && (
                    <span className="flex-shrink-0 inline-block px-1.5 py-0.5 rounded bg-accent-100 text-accent-600 text-xs font-medium whitespace-nowrap">
                      NEW
                    </span>
                  )}
                </div>
                <span className="inline-block px-2 py-0.5 rounded-md bg-secondary-50 text-secondary-600 text-xs font-medium whitespace-nowrap">
                  {item.tag}
                </span>
              </div>

              <div className="flex-shrink-0 text-right">
                <div className="flex items-center gap-1 text-primary-500">
                  <i className="ri-fire-line text-sm"></i>
                  <span className="text-sm font-semibold whitespace-nowrap">{item.heat}</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}